export default "__VITE_ASSET__QBfX8ZH7__"